import { WorkspaceDto } from '@mark43/cad-api';
import { useLocation } from 'react-router-dom';
import { useCallback } from 'react';
import { useApplicationType } from '../common/hooks/use-application-type';
import { electronBridge } from '../electron-bridge/electron-bridge';

export function useGetWorkspaceWindowIdForLocation() {
    const { isCad } = useApplicationType();
    return useCallback(
        (location: ReturnType<typeof useLocation>, workspace: WorkspaceDto) => {
            if (isCad) {
                if (electronBridge) {
                    return electronBridge.args['--workspace-window-id'];
                }
                if (location.pathname === '/events') {
                    const eventV2WorkspaceWindow = workspace.workspaceWindows.find(
                        (workspaceWindow) => workspaceWindow.windowType === 'EVENT_V2'
                    )!;
                    return eventV2WorkspaceWindow.id;
                } else {
                    const queueV2WorkspaceWindow = workspace.workspaceWindows.find(
                        (workspaceWindow) => workspaceWindow.windowType === 'QUEUE_V2'
                    )!;
                    return queueV2WorkspaceWindow.id;
                }
            } else {
                throw new Error('First Responder does not have an active workspace window id');
            }
        },
        [isCad]
    );
}
